import {PATH_PLUGINS} from "../../../constants/paths";

export const parsingDataToMenu = (plugins) => {
    return plugins.map(plugin => !!plugin.Enabled && !!plugin.MainMenuEnabled &&  ({
        label: plugin.MenuName,
        path: `${PATH_PLUGINS}?uid=${plugin.PluginUid}`,
        blackIconPath: plugin.icon || './static/png/artefact-browser.png',
        redIconPath: plugin.icon || './static/png/artefact-browser_red.png',
        ...plugin
    }))
};
